module.exports = __webpack_public_path__ + "img/hima_yes.f2dc79f0.png";